module.exports = "<script type=\"text/html\" id=\"survey-string\">\n    <!-- ko ifnot: koHasHtml -->\n    <span style=\"position: static;\" data-bind=\"text: koRenderedHtml\"></span>\n    <!-- /ko -->\n    <!-- ko if: koHasHtml -->\n    <span style=\"position: static;\" data-bind=\"html: koRenderedHtml\"></span>\n    <!-- /ko -->\n</script>\n";


//////////////////
// WEBPACK FOOTER
// ./src/knockout/templates/string.html
// module id = 104
// module chunks = 0